export { ResidentsService } from './residents.service';
